import { render, staticRenderFns } from "./Ekran_game.vue?vue&type=template&id=44f85596"
import script from "./Ekran_game.vue?vue&type=script&lang=js"
export * from "./Ekran_game.vue?vue&type=script&lang=js"
import style0 from "./Ekran_game.vue?vue&type=style&index=0&id=44f85596&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports